const Entidades = {
	namespaced: true,
	state: {
		listaUFs: [],
		listaTipoLogradouro: [],
		listaEscolaridade: [],
		listaHabilitacoes: [],
		listaExperiencias: [],
		listaAgencias: [],
		listaCBO: [],
		listaBeneficios: [],
		listaMotivoContratacao: [],
		listaSetores: [],
	},
	mutations: {
		setListaUFs(state, value) {
			state.listaUFs = value;
		},
		setListaTipoLogradouro(state, value) {
			state.listaTipoLogradouro = value;
		},
		setListaEscolaridade(state, value) {
			state.listaEscolaridade = value;
		},
		setListaHabilitacoes(state, value) {
			state.listaHabilitacoes = value;
		},
		setListaExperiencias(state, value) {
			state.listaExperiencias = value;
		},
		setListaAgencias(state, value) {
			state.listaAgencias = value;
		},
		setListaCBO(state, value) {
			state.listaCBO = value;
		},
		setListaBeneficios(state, value) {
			state.listaBeneficios = value;
		},
		setListaMotivoContratacao(state, value) {
			state.listaMotivoContratacao = value;
		},
		setListaSetores(state, value) {
			state.listaSetores = value;
		},
	},
	actions: {},
	getters: {
		getListaUFs: (state) => (state.listaUFs),
		getListaTipoLogradouro: (state) => (state.listaTipoLogradouro),
		getListaEscolaridade: (state) => (state.listaEscolaridade),
		getListaHabilitacoes: (state) => (state.listaHabilitacoes),
		getListaExperiencias: (state) => (state.listaExperiencias),
		getListaAgencias: (state) => (state.listaAgencias),
		getListaCBO: (state) => (state.listaCBO),
		getListaBeneficios: (state) => (state.listaBeneficios),
		getListaMotivoContratacao: (state) => (state.listaMotivoContratacao),
		getListaSetores: (state) => (state.listaSetores),
	},
};

export default Entidades;
